import React from "react";
import { Expression } from "@progress/kendo-react-data-tools";
import BaseButton, { AddButton, DeleteButton } from "../buttons"
import { ButtonGroup } from "@progress/kendo-react-buttons";
import styled from 'styled-components'

import './style.scss'
const OPERATOR_AND = 'and';
const OPERATOR_OR = 'or';

const GroupFilter = ({ fields, value, onChange, onRemove, connectToParent = true, deletable = true }) => {

  const handleChange = (event) => {

    const { prevFilter, nextFilter } = event;
    const filters = value.filters.map(x => x === prevFilter ? nextFilter : x);
    const changeEvent = {
      nextFilter: { ...value, filters },
      prevFilter: value,
      syntheticEvent: event.syntheticEvent,
      nativeEvent: event.nativeEvent,
      target: this
    };
    onChange.call(undefined, changeEvent)
  };

  const handleRemove = event => {

    const filters = value.filters.filter(f => f !== event.filter);
    const changeEvent = {
      nextFilter: { ...value, filters },
      prevFilter: value,
      syntheticEvent: event.syntheticEvent,
      nativeEvent: event.nativeEvent,
      target: this
    };
    onChange.call(undefined, changeEvent)
  }

  const changeLogic = (event, logic) => {

    if (value.logic !== logic) {
      const e = {
        nextFilter: { ...value, logic },
        prevFilter: value,
        target: this,
        syntheticEvent: event,
        nativeEvent: event.nativeEvent
      };

      onChange.call(undefined, e);
    }
  };

  const handleAddExpressiion = event => {

    const newExpression = { field: fields[0].name, operator: fields[0].operators[0].operator };
    const nextFilter = { ...value, filters: [...value.filters, newExpression] };

    const ev = {
      prevFilter: value,
      nextFilter,
      target: this,
      syntheticEvent: event,
      nativeEvent: event.nativeEvent
    };

    onChange.call(undefined, ev);
  };

  const handleDeleteGroup = event => {

    const e = {
      filter: value,
      syntheticEvent: event.syntheticEvent,
      nativeEvent: event.nativeEvent,
      target: this
    };

    onRemove.call(undefined, e);
  }

  return <>
    <div className={connectToParent ? 'k-filter-toolbar' : ''} role="toolbar">
      <ButtonGroup>
        <BaseButton title='Or' togglable={true} selected={value.logic === OPERATOR_OR} onClick={(e) => changeLogic(e, OPERATOR_OR)} />
        <BaseButton title='And' togglable={true} selected={value.logic === OPERATOR_AND} onClick={(e) => changeLogic(e, OPERATOR_AND)} />
      </ButtonGroup>
    </div>
    <ul className="k-filter-lines">
      {value.filters?.map((f, idx) => (
        <li key={idx} className="k-filter-item" >
          <Expression
            filter={f}
            fields={fields}
            onChange={handleChange}
            onRemove={handleRemove}
          />
        </li>
      ))}
    </ul>
    <AddButton title='Add Row' onClick={handleAddExpressiion} />
    {deletable && <DeleteButton title='Delete Group' style={{ float: 'right' }} onClick={handleDeleteGroup} />}
  </>
}

export default GroupFilter;